import React from "react"
import { obterPorProtocolo, obterComplementos } from '../services/DenunciaServico'
import RenderizarDenuncia from '../components/RenderizarDenuncia'
import { IoIosSearch, IoIosArrowRoundBack } from "react-icons/io";

export default function CorrespondenciaEntregue(props) {
    
    if (!props.linhaDoTempo) {
        return null;
    }
    if (props.linhaDoTempo.emPauta !== "correspondenciaEntregue") {
        return null;
    }

    const obterRotulo = () => {
        let rotulo = "Denúncia recebida."
        if (props.complementacao !== "") {
            rotulo = "Complementação recebida."
        }
        return rotulo
    }

    const buscaPeloProtocolo = () => {
        obterPorProtocolo(props.correspondenciaEntregue.protocolo)
        .then( _denuncia => {
            let denuncia = {}
            denuncia.denuncia = _denuncia.denuncia
            denuncia.denuncia.idsFotocopias = _denuncia.denuncia.idsFotocopias
            obterComplementos(denuncia.denuncia)
            .then( complementos => {
                denuncia.denuncia.complementos = complementos
                props.setRenderizarDenuncia({ denuncia:denuncia.denuncia, show:true })
            })
            .catch( erroObterComplementos => {
                props.setRenderizarDenuncia({ denuncia:'', show:false })
            })
        })
        .catch( msgErroDenuncia => {
            props.setRenderizarDenuncia({ denuncia:'', show:false })
        })
    }

    if (props.renderizarDenuncia.show) {
        return(
            <RenderizarDenuncia 
                usuarioLogado={ props.usuarioLogado }
                renderizarDenuncia={ props.renderizarDenuncia }
                setRenderizarDenuncia={ props.setRenderizarDenuncia } 
            /> 
        )
    }

    return (
        <div className="formulario">
            <div className="card">
                <div className="card-header text-primary">
                    <div className="ml-3">
                        Protocolo: <strong>{ props.correspondenciaEntregue.protocolo }</strong>
                    </div>
                </div>
                <div className="card-body ml-3">
                    <h5 className="card-title">{ obterRotulo() }</h5>
                    <p className="card-text mt-4">
                        <strong className='mr-1'>
                            Importante:
                        </strong> 
                        Guarde o protocolo acima para acompanhar as postagens.
                    </p>
                </div>
                <div className="card-footer">
                    <div className="d-flex justify-content-between">
                        <button 
                            type="button" 
                            className="btn btn-link"
                            onClick={ () => props.atuLinhaDoTempo('contato')}>
                            <div>
                                <IoIosArrowRoundBack />Voltar
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}